import { CartLinesUpdateEvent } from "@shopify/events";

(function () {
  if (window.__skProductCartSyncInstalled) return;
  window.__skProductCartSyncInstalled = true;

  document.addEventListener("submit", async function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches("#MainContent #skp- .skp__form")) {
      if (!form.closest('[id^="skp-"]') || !form.matches(".skp__form")) return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const root = form.closest('[id^="skp-"]');
    const button = root?.querySelector("[data-add]");
    const label = root?.querySelector("[data-add-label]");
    const message = root?.querySelector("[data-message]");
    const variantInput = form.querySelector("[data-variant-id]");
    const quantityInput = form.querySelector("[data-quantity]");
    const variantId = variantInput?.value;
    const quantity = Math.max(1, Number(quantityInput?.value) || 1);

    if (!variantId || button?.disabled) return;

    const originalLabel = label?.textContent || "";
    if (button) button.disabled = true;
    if (message) message.textContent = "";

    const cartComponents = Array.from(document.querySelectorAll("cart-items-component[data-section-id]"));
    const sectionIds = [...new Set(cartComponents.map((component) => component.dataset.sectionId).filter(Boolean))];
    const formData = new FormData(form);
    formData.set("id", variantId);
    formData.set("quantity", String(quantity));
    if (sectionIds.length) {
      formData.set("sections", sectionIds.join(","));
      formData.set("sections_url", window.location.pathname + window.location.search);
    }

    try {
      const actionUrl = new URL(form.action, window.location.origin);
      actionUrl.pathname = actionUrl.pathname.replace(/\/$/, "") + ".js";

      const addResponse = await fetch(actionUrl.toString(), {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
        credentials: "same-origin"
      });
      const added = await addResponse.json();
      if (!addResponse.ok || added.status) {
        throw new Error(added.description || added.message || "Could not add this item.");
      }

      const rootPath = window.Shopify?.routes?.root || "/";
      const cartResponse = await fetch(rootPath + "cart.js", {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        cache: "no-store"
      });
      if (!cartResponse.ok) throw new Error("The item was added, but the cart could not be refreshed.");
      const cart = await cartResponse.json();

      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new CartLinesUpdateEvent({
        action: "add",
        context: "product",
        lines: [{ merchandiseId: String(variantId), quantity }],
        promise: deferred.promise
      }));
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          sections: added.sections || {},
          source: "sk-product-page",
          itemCount: quantity,
          didError: false
        }
      });

      if (label) label.textContent = "Added ✓";
      if (message) message.textContent = "Added to your bag";
      window.setTimeout(() => {
        if (label && label.textContent === "Added ✓") label.textContent = originalLabel;
      }, 1400);
    } catch (error) {
      if (message) message.textContent = error?.message || "Could not add this item. Please try again.";
      if (label) label.textContent = originalLabel;
    } finally {
      const variants = JSON.parse(root?.querySelector("[data-skp-variants]")?.textContent || "[]");
      const selectedId = variantInput?.value;
      const selectedVariant = variants.find((variant) => String(variant.id) === String(selectedId));
      if (button) button.disabled = !selectedVariant?.available;
    }
  }, true);
})();